import {SkeletonBox, SkeletonText} from '@primer/react/experimental'
import {clsx} from 'clsx'
import {SidebarSection} from '@github-ui/pull-requests/components/overview/SidebarSection'
import styles from './MergeStatusSkeleton.module.css'

function MergeStatusRowSkeleton() {
  return (
    <div className={clsx(styles.row, 'd-flex flex-items-center gap-2 py-1')}>
      <SkeletonBox height="16px" width="16px" />
      <SkeletonText size="bodySmall" className={styles.rowText} />
    </div>
  )
}

/**
 * Server-rendered placeholder for the "Merge status" section. The section's data is
 * fetched client-side (see `useSuspenseMergeBoxPageData`), so without this skeleton the
 * section renders nothing during SSR and pushes the rest of the sidebar down once the
 * data resolves. Reserving a fixed-height block here keeps the sidebar layout stable.
 *
 * The section header title is static and matches the real section, so only the data rows
 * and merge button are rendered as skeletons.
 */
export function MergeStatusSkeleton() {
  return (
    <SidebarSection title="Merge status">
      <div className="d-flex flex-column" aria-hidden="true">
        <MergeStatusRowSkeleton />
        <MergeStatusRowSkeleton />
      </div>
    </SidebarSection>
  )
}
